module.exports = __webpack_public_path__ + "img/13.2ab4ee37.png";